import UserFieldBase from "./base";

export default class UserFieldMultiselect extends UserFieldBase {}
